/**
 * user account operations
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


import {USER_ACCOUNT_PAGE} from "../redux/view/consts";
import {openPageAction} from "../redux/view/actions";
import {executeSimpleServerCommand} from "../operations/communication";
import {REST_SERVER_BASE_URL} from "../config";


export function openUserAccountPage() {
    return async (dispatch, getState) => {
        dispatch(openPageAction(USER_ACCOUNT_PAGE));
    }
}

export function changeOwnPassword(oldPassword, newPassword) {
    return executeSimpleServerCommand("changing password", "POST", REST_SERVER_BASE_URL + "/changeownpassword", {
        oldpassword: oldPassword,
        newpassword: newPassword
    });
}